// extracted by mini-css-extract-plugin
export var activeFilterButton = "_n4-c";
export var backButton = "_n4-4";
export var backIcon = "_n4-5";
export var chevronShortcut = "_n4-6";
export var container = "_n4-1";
export var editor = "_n4-8";
export var editorWrapper = "_n4-7";
export var prefix = "_n4-2";
export var searchIcon = "_n4-3";
export var suffix = "_n4-9";
export var suffixContent = "_n4-a";
export var suffixText = "_n4-b";
export var wrapper = "_n4-0";